"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TextSpan_1 = __importDefault(require("./TextSpan"));

exports.default = TextSpan_1.default;